'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputGroup = require('react-bootstrap/lib/InputGroup');

var _InputGroup2 = _interopRequireDefault(_InputGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _InputGroup2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/InputGroup.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/InputGroup.js
 ** module chunks = 0
 **/